module.exports = __webpack_public_path__ + "778189690c221d039e6f2ecf8776c5af.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/torque-webfont/torque-medium.woff
// module id = 85
// module chunks = 0